import React from 'react';

const MVTab = ({ project }) => {
  const totalActualSavingsAud =
    project.project_actuals?.reduce(
      (sum, actual) => sum + (actual.actual_savings_aud || 0),
      0,
    ) || 0;

  const performanceVsEstimate =
    project.project_actuals && project.project_actuals.length > 0
      ? Math.round(
          (totalActualSavingsAud / (project.estimated_savings_aud || 1)) * 100,
        )
      : 0;

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
          Measurement & Verification
        </h3>
        <button className="px-4 py-2 bg-green-600 dark:bg-green-700 text-white rounded-md hover:bg-green-700 dark:hover:bg-green-800">
          Add M&V Period
        </button>
      </div>

      {/* Actual Performance Chart */}
      <div className="bg-white dark:bg-gray-800 p-6 rounded-lg border border-gray-200 dark:border-gray-700">
        <h4 className="font-semibold mb-4 text-gray-900 dark:text-white">
          Actual vs Estimated Performance
        </h4>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
          <div className="text-center">
            <div className="text-2xl font-bold text-blue-600 dark:text-blue-400">
              {project.estimated_savings_aud?.toLocaleString() || 0}
            </div>
            <div className="text-sm text-blue-600 dark:text-blue-400">
              Estimated Savings (AUD/yr)
            </div>
          </div>
          <div className="text-center">
            <div className="text-2xl font-bold text-green-600 dark:text-green-400">
              {totalActualSavingsAud.toLocaleString() || 0}
            </div>
            <div className="text-sm text-green-600 dark:text-green-400">
              Actual Savings (AUD/yr)
            </div>
          </div>
          <div className="text-center">
            <div className="text-2xl font-bold text-purple-600 dark:text-purple-400">
              {performanceVsEstimate}%
            </div>
            <div className="text-sm text-purple-600 dark:text-purple-400">
              Performance vs Estimate
            </div>
          </div>
        </div>
      </div>

      {/* M&V Records */}
      <div className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden">
        <table className="w-full">
          <thead className="bg-gray-50 dark:bg-gray-700">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase">
                Period
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase">
                Savings (kWh)
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase">
                Savings (AUD)
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase">
                Notes
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
            {(project.project_actuals || []).map((actual) => (
              <tr key={actual.id}>
                <td className="px-6 py-4 text-sm text-gray-900 dark:text-white">
                  {actual.period_start} to {actual.period_end}
                </td>
                <td className="px-6 py-4 text-sm text-gray-900 dark:text-white">
                  {actual.actual_savings_kwh?.toLocaleString() || '-'}
                </td>
                <td className="px-6 py-4 text-sm text-gray-900 dark:text-white font-medium">
                  ${actual.actual_savings_aud?.toLocaleString() || '-'}
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 dark:text-gray-400">
                  {actual.notes || '-'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {(!project.project_actuals || project.project_actuals.length === 0) && (
          <div className="text-center py-8 text-gray-500 dark:text-gray-400">
            No M&V data recorded yet. Add actual performance data to track project success.
          </div>
        )}
      </div>
    </div>
  );
};

export default MVTab;


